import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { ImageUpload } from "@/components/DesignPanel";

const uid = () => `s${Math.random().toString(36).slice(2, 9)}`;
const inputCls = "w-full h-9 px-3 rounded-md bg-[#0B0F17] border border-[#242C3D] text-sm focus:border-indigo-500 focus:outline-none";
const mini = "h-7 w-7 grid place-items-center rounded-md text-slate-400 hover:text-white hover:bg-white/5 transition-colors";

export const SpeakersEditor = ({ heading, speakers, set }) => {
  const upd = (i, patch) => set({ speakers: speakers.map((s, j) => (j === i ? { ...s, ...patch } : s)) });
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= speakers.length) return;
    const a = [...speakers];
    [a[i], a[j]] = [a[j], a[i]];
    set({ speakers: a });
  };
  return (
    <div className="space-y-4" data-testid="speakers-editor">
      <div className="flex items-center gap-3">
        <input data-testid="speakers-heading-input" value={heading} onChange={(e) => set({ speakers_heading: e.target.value })} placeholder="Section heading, e.g. Featured speakers" className={inputCls} />
        <button type="button" data-testid="speaker-add-button" disabled={speakers.length >= 8}
          onClick={() => set({ speakers: [...speakers, { id: uid(), name: "", title: "", photo_path: "" }] })}
          className="h-9 px-3 shrink-0 rounded-md border border-dashed border-[#2f3a50] hover:border-indigo-500 text-xs text-slate-400 hover:text-white flex items-center gap-1.5 transition-colors disabled:opacity-40">
          <Plus className="w-3.5 h-3.5" /> Add speaker
        </button>
      </div>
      {speakers.length === 0 && <p className="text-xs text-slate-500">No speakers — the section is hidden on the page.</p>}
      {speakers.map((s, i) => (
        <div key={s.id} data-testid={`speaker-row-${s.id}`} className="flex flex-wrap items-center gap-3 rounded-md border border-[#242C3D] bg-[#0B0F17]/60 p-3">
          <ImageUpload value={s.photo_path} onChange={(p) => upd(i, { photo_path: p })} testid={`speaker-photo-${s.id}`} emptyLabel="Photo" />
          <input data-testid={`speaker-name-${s.id}`} value={s.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Full name *" className={`${inputCls} flex-1 min-w-36`} />
          <input data-testid={`speaker-title-${s.id}`} value={s.title} onChange={(e) => upd(i, { title: e.target.value })} placeholder="Job title, Company" className={`${inputCls} flex-1 min-w-44`} />
          <div className="flex">
            <button type="button" onClick={() => move(i, -1)} className={mini} title="Move up"><ArrowUp className="w-3.5 h-3.5" /></button>
            <button type="button" onClick={() => move(i, 1)} className={mini} title="Move down"><ArrowDown className="w-3.5 h-3.5" /></button>
            <button type="button" data-testid={`speaker-delete-${s.id}`} onClick={() => set({ speakers: speakers.filter((_, j) => j !== i) })} className={`${mini} hover:!text-rose-400`} title="Remove"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
